/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-var: 0 */
/* globals _, Backbone, mixpanel, mp */

var purchase_tpl = require(`./templates/purchase.pug`);

_.namespace(`Backbone.widgets`, function(ns) {
  "use strict";

  var SignupFreePlanFlow = Backbone.TemplateView.extend({
    templates: {
      base: purchase_tpl,
    },

    events: {
      'click .back-button': `hide`,
      'click .contact.show-modal': `hide`,
      'click .exit': `hide`,
    },

    initialize(options) {
      this.source = options.source;
      this.step_source = options.source;
      Backbone.TemplateView.prototype.initialize.apply(this, arguments);
    },

    render_base_template() {
      this.$template = $(this.templates.base());
      this.$el.html(this.$template);
      $(`body`).append(this.$el);
    },

    render() {
      this.render_base_template();
      this.signup_form = new Backbone.widgets.SignupForm({
        $overlay: this.$template,
        purchase_flow: this,
        source: this.source,
        step_source: this.step_source,
      });
      this.signup_form.render();
      this.signup_form.on(`back`, _.bind(function() {
        this.signup_form.hide();
        this.handle_previous_step();
      }, this));
      this.$purchase = this.$el.find(`#purchase`);
    },

    handle_signup_continue(redirect_url) {
      this.handle_redirect(redirect_url);
    },

    handle_redirect(redirect_url) {
      window.location.href = redirect_url;
    },

    show(email) {
      this.render();
      this.$template.show();
      this.signup_form.show(email, true);
      this.signup_form.hide_back_button();
      this.$purchase.addClass(`visible`);
      $(`body`).css(`overflow`, `hidden`);
      mp.utility.bind_esc(this.cid, this.hide, this);
    },

    hide() {
      this.$purchase.one(mp.utility.CSS_TRANSITION_END_EVENTS, _.bind(function(ev) {
        this.$template.hide();
        $(`body`).css(`overflow`, ``);
      }, this));

      this.$purchase.removeClass(`visible`);
      mp.utility.unbind_esc(this.cid);

      mixpanel.track(`Signup Closed`, {
        source: this.step_source,
      });
    },
  });

  return {
    SignupFreePlanFlow,
  };
});

}.call(window));